import { render, staticRenderFns } from "./WrapperMapLegend.vue?vue&type=template&id=1c04f64a&scoped=true&"
import script from "./WrapperMapLegend.vue?vue&type=script&lang=ts&"
export * from "./WrapperMapLegend.vue?vue&type=script&lang=ts&"
import style0 from "./WrapperMapLegend.vue?vue&type=style&index=0&id=1c04f64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c04f64a",
  null
  
)

export default component.exports